import _, { isEqual } from 'lodash-es';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  copyInputField,
  copySelectedInputFields,
  deleteInputField,
  deleteSelectedInputFields,
  updateSelectedInputFields,
  equalizeSelectedRowGaps,
  getFormEditorControlData,
  getSelectedFormEditorForm,
  onInputFieldChange,
} from '../../store/slices/formEditorSlice';

export default function RightColumnFieldEditor({
  selectedInputField,
  selectedInputFieldIds = [],
  selectedPageIndex = 0,
}) {
  const typeOptions = [
    {
      label: 'Yleinen kategoria',
      options: [{ name: 'text', displayName: 'Teksti' }],
    },
    {
      label: 'Valinta kategoria',
      options: [
        { name: 'checkBox', displayName: 'Valintaruutu checkbox' },
        { name: 'radioButton', displayName: 'Valintanappi radio' },
      ],
    },
    {
      label: 'Aika kategoria',
      options: [
        { name: 'fullDate', displayName: 'Päivämäärä (pp.kk.vvvv)' },
        {
          name: 'manualFullDate',
          displayName: 'Päivämäärä (pp.kk.vvvv) - ei automaattista päiväystä',
        },
        { name: 'dateMonthAndYear', displayName: 'Kuukausi ja vuosi (kk/vv)' },
        { name: 'dateWeekNumber', displayName: 'Viikkonumero (v)' },
        { name: 'dateYear', displayName: 'Vuosi' },
        { name: 'dateWeekDay', displayName: 'Viikonpäivä' },
        { name: 'dateTimeClock', displayName: 'Kellonaika' },
      ],
    },

    {
      label: 'Täyttäjä kategoria',
      options: [
        { name: 'fillerName', displayName: 'Täyttäjän nimi' },
        { name: 'fillerPhone', displayName: 'Täyttäjän puh' },
        { name: 'fillerCompany', displayName: 'Täyttäjän yritys' },
        { name: 'fillerEmail', displayName: 'Täyttäjän sähköposti' },
        { name: 'fillerTaxNumber', displayName: 'Täyttäjän veronumero' },
        { name: 'fillerBirthDate', displayName: 'Täyttäjän syntymäaika' },
      ],
    },

    {
      label: 'Projekti kategoria',
      options: [
        { name: 'projectName', displayName: 'Projektin nimi' },
        { name: 'projectSiteKey', displayName: 'Projektin työmaa-avain' },
        { name: 'projectAddress', displayName: 'Projektin osoite' },
        {
          name: 'clientCompanyName',
          displayName: 'Asiakkaan yrityksen nimi (projektin yhteystieto)',
        },
        {
          name: 'workerList',
          displayName: 'Työntekijälista (kaikki työmaalle rekisteröityneet)',
        },
        {
          name: 'clockedInWorkerList',
          displayName:
            'Työntekijälista (työmaalle leimanneet käyttäjät täyttöhetkellä)',
        },
        { name: 'siteContactPerson', displayName: 'Työmaan yhteyshenkilö' },
        {
          name: 'siteContactPhone',
          displayName: 'Työmaan yhteyshenkilön puhelin',
        },
        {
          name: 'siteContactEmail',
          displayName: 'Työmaan yhteyshenkilön sähköposti',
        },
      ],
    },

    {
      label: 'Kuva kategoria',
      options: [
        {
          name: 'image',
          displayName: 'Kuva (voi ottaa kuvan tai lisätä tiedostoista)',
        },
        {
          name: 'imageWithCrop',
          displayName:
            'kuvalla on määritelty alue. Kuvia voi käyttöliittymässä cropata sopivan kokoisiksi.',
        },
        // {
        //   name: 'imageAsAttachment',
        //   displayName: 'Kuva liitteeksi (kuva tulee lomakkeen jatkoksi)',
        // },
        // { name: 'imageCaption', displayName: 'Kuvateksti' },
      ],
    },
    {
      label: 'Sää',
      options: [
        { name: 'weatherMorning', displayName: 'Sää - Aamu' },
        { name: 'weatherDay', displayName: 'Sää - Päivä' },
        { name: 'weatherEvening', displayName: 'Sää - Ilta' },
        { name: 'weatherNight', displayName: 'Sää - Yö' },
      ],
    },
    {
      label: 'Muut kategoria',
      options: [
        { name: 'signature', displayName: 'Allekirjoitus' },
        { name: 'runningNumber', displayName: 'Juokseva numero' },
      ],
    },
  ];

  const styles = useMemo(() => {
    const card = {
      backgroundColor: '#005a7f',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      padding: 14,
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
    };
    const label = {
      fontSize: 11,
      letterSpacing: 0.4,
      textTransform: 'uppercase',
      color: 'rgba(255,255,255,0.6)',
      marginBottom: 6,
    };
    const input = {
      width: '100%',
      padding: '10px 12px',
      border: '1px solid rgba(255,255,255,0.15)',
      backgroundColor: 'rgba(0,90,127,0.3)',
      color: '#fff',
      outline: 'none',
    };
    const btn = {
      border: 'none',
      borderRadius: 12,
      padding: '9px 12px',
      color: '#0f1220',
      fontWeight: 600,
      cursor: 'pointer',
      background: 'linear-gradient(180deg, #79ffe1 0%, #4ad3ff 100%)',
      boxShadow: '0 6px 14px rgba(74, 211, 255, 0.25)',
    };
    const textBtn = {
      ...btn,
      background: 'transparent',
      color: '#d8e8ff',
      border: '1px solid rgba(216,232,255,0.25)',
      boxShadow: 'none',
    };
    const dangerBtn = {
      border: 'none',
      borderRadius: 12,
      padding: '9px 12px',
      fontWeight: 700,
      cursor: 'pointer',
      background: 'linear-gradient(180deg, #ff8a6b 0%, #ff5b5b 100%)',
      color: '#2b0d0d',
      boxShadow: '0 6px 14px rgba(255, 91, 91, 0.25)',
    };

    return {
      panel: {
        ...card,
        width: 360,
        display: 'grid',
        gap: 12,
      },
      headerRow: {
        fontSize: 16,
        fontWeight: 800,
        marginBottom: 4,
        color: '#fff',
      },
      grid2: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 10,
      },
      field: { display: 'grid', gap: 8 },
      label,
      input,
      select: input,
      footer: {
        marginTop: 6,
        display: 'flex',
        gap: 10,
        justifyContent: 'flex-start',
      },
      btn,
      textBtn,
      dangerBtn,
    };
  }, []);

  const dispatch = useDispatch();
  const { hasUnsavedChanges } = useSelector(getFormEditorControlData);
  const selectedForm = useSelector(getSelectedFormEditorForm);
  const [formData, setFormData] = useState({
    x: 0,
    y: 0,
    width: 100,
    height: 30,
    parentTitle: '',
    subTitle: '',
    text: '',
    title: '',
    type: null,
    textSize: 14,
    originalIndex: null,
  });

  const savedParentTitles = useMemo(() => {
    if (!selectedForm?.inputFields) return [];

    const currentPageFields = Array.isArray(selectedForm.inputFields[0])
      ? selectedForm.inputFields[selectedPageIndex] || []
      : selectedForm.inputFields;

    const uniqueTitles = [
      ...new Set(
        currentPageFields
          .filter((field) => {
            const title =
              typeof field.parentTitle === 'object'
                ? field.parentTitle?.title
                : field.parentTitle;
            return title && title.trim();
          })
          .map((field) => {
            const title =
              typeof field.parentTitle === 'object'
                ? field.parentTitle.title
                : field.parentTitle;
            return title.trim();
          })
      ),
    ];

    return uniqueTitles;
  }, [selectedForm, selectedPageIndex]);

  const checkboxAndRadioButtons = useMemo(() => {
    if (!selectedForm?.inputFields) return [];

    const currentPageFields = Array.isArray(selectedForm.inputFields[0])
      ? selectedForm.inputFields[selectedPageIndex] || []
      : selectedForm.inputFields;

    return currentPageFields.filter((field) => {
      return (
        field.type?.name === 'checkBox' || field.type?.name === 'radioButton'
      );
    });
  }, [selectedForm?.inputFields, selectedPageIndex]);

  // A field is only shown once the field it depends on is ticked, so a circular
  // dependency hides every field in the circle for good. These are the fields
  // the selected field can't depend on: itself and whatever depends on it.
  const fieldIdsDependingOnSelected = useMemo(() => {
    if (!selectedForm?.inputFields || !selectedInputField) return new Set();

    const currentPageFields = Array.isArray(selectedForm.inputFields[0])
      ? selectedForm.inputFields[selectedPageIndex] || []
      : selectedForm.inputFields;

    const fieldsById = new Map(
      currentPageFields.map((field) => [field.id, field])
    );

    const dependsOnSelected = (field) => {
      const visitedIds = new Set();
      let current = field;

      while (current && !visitedIds.has(current.id)) {
        if (current.id === selectedInputField.id) return true;
        visitedIds.add(current.id);
        current = fieldsById.get(current.dependency);
      }
      return false;
    };

    return new Set(
      currentPageFields.filter(dependsOnSelected).map((field) => field.id)
    );
  }, [selectedForm?.inputFields, selectedPageIndex, selectedInputField?.id]);

  // A form can only have one running number, on any of its pages.
  const hasOtherRunningNumberField = useMemo(
    () =>
      (selectedForm?.inputFields || [])
        .flat()
        .some(
          (field) =>
            field.type?.name === 'runningNumber' &&
            field.id !== selectedInputField?.id
        ),
    [selectedForm?.inputFields, selectedInputField?.id]
  );

  const savedSubTitles = useMemo(() => {
    if (!selectedForm?.inputFields || !formData.parentTitle) return [];

    const currentPageFields = Array.isArray(selectedForm.inputFields[0])
      ? selectedForm.inputFields[selectedPageIndex] || []
      : selectedForm.inputFields;

    const currentParentTitle =
      typeof formData.parentTitle === 'object'
        ? formData.parentTitle.title
        : formData.parentTitle;

    const uniqueSubTitles = [
      ...new Set(
        currentPageFields
          .filter((field) => {
            const fieldParentTitle =
              typeof field.parentTitle === 'object'
                ? field.parentTitle?.title
                : field.parentTitle;
            return (
              field.subTitle &&
              field.subTitle.trim() &&
              fieldParentTitle === currentParentTitle
            );
          })
          .map((field) => field.subTitle.trim())
      ),
    ];

    return uniqueSubTitles;
  }, [selectedForm, selectedPageIndex, formData.parentTitle]);

  const selectParentTitle = (title) => {
    const groupNumber = savedParentTitles.indexOf(title) + 1;
    const parentTitleObj = { title, groupNumber };
    const newFormData = { ...formData, parentTitle: parentTitleObj };
    setFormData(newFormData);

    if (selectedInputField) {
      const updated = { id: selectedInputField.id, ...newFormData };
      dispatch(
        onInputFieldChange({
          updatedInputField: updated,
          pageIndex: selectedPageIndex,
        })
      );
    }
  };

  const selectSubTitle = (subTitle) => {
    const newFormData = { ...formData, subTitle };
    setFormData(newFormData);

    if (selectedInputField) {
      const updated = { id: selectedInputField.id, ...newFormData };
      dispatch(
        onInputFieldChange({
          updatedInputField: updated,
          pageIndex: selectedPageIndex,
        })
      );
    }
  };

  const selectDependency = (dependency) => {
    const newFormData = { ...formData, dependency };
    setFormData(newFormData);

    if (selectedInputField) {
      const updated = { id: selectedInputField.id, ...newFormData };
      dispatch(
        onInputFieldChange({
          updatedInputField: updated,
          pageIndex: selectedPageIndex,
        })
      );
    }
  };

  const history = useHistory();

  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const unblock = history.block(
      'Sinulla on tallentamattomia muutoksia, Haluatko varmasti poistua sivulta?'
    );

    return () => unblock();
  }, [hasUnsavedChanges, history]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!hasUnsavedChanges) return;
      e.preventDefault();
      e.returnValue = ''; // required for Chrome
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (!selectedInputField) return;
    const newFormData = {
      x: selectedInputField.x,
      y: selectedInputField.y,
      width: selectedInputField.width,
      height: selectedInputField.height,
      text: selectedInputField.text,
      title: selectedInputField.title ?? '',
      parentTitle: selectedInputField.parentTitle ?? '',
      subTitle: selectedInputField.subTitle ?? '',
      type: selectedInputField.type,
      textSize: selectedInputField.textSize,
      originalIndex: selectedInputField.originalIndex,
    };

    if (!isEqual(newFormData, formData)) {
      setFormData(newFormData);
    }
  }, [selectedInputField]);

  const handleChange = (e) => {
    if (!selectedInputField) return;

    const { name, type, value, checked } = e.target;

    let updatedValue = type === 'checkbox' ? checked : value;

    if (name === 'type') {
      const allOptions = typeOptions.flatMap((group) => group.options);
      const selectedTypeObj = allOptions.find((opt) => opt.name === value);
      updatedValue = selectedTypeObj || null;
    }

    const numericFields = [
      'x',
      'y',
      'width',
      'height',
      'textSize',
      'originalIndex',
    ];
    if (numericFields.includes(name)) {
      updatedValue = Number(updatedValue);
    }

    if (name === 'parentTitle' && updatedValue) {
      const allTitles = [...savedParentTitles, updatedValue];
      if (allTitles.length !== 1) allTitles.shift();

      const groupNumber = allTitles.indexOf(updatedValue) + 1;
      updatedValue = { title: updatedValue, groupNumber };
    } else if (name === 'parentTitle' && !updatedValue) {
      updatedValue = '';
    }

    const newFormData = {
      ...formData,
      [name]: updatedValue,
    };

    setFormData(newFormData);

    const updated = { id: selectedInputField.id, ...newFormData };

    dispatch(
      onInputFieldChange({
        updatedInputField: updated,
        pageIndex: selectedPageIndex,
      })
    );
  };

  const onDeleteInputField = () => {
    dispatch(
      deleteInputField({
        id: selectedInputField.id,
        pageIndex: selectedPageIndex,
      })
    );
  };
  const onCopyInputField = () => {
    dispatch(
      copyInputField({
        id: selectedInputField.id,
        pageIndex: selectedPageIndex,
      })
    );
  };

  const onCopySelectedFields = () => {
    dispatch(copySelectedInputFields({ pageIndex: selectedPageIndex }));
  };

  const onDeleteSelectedFields = () => {
    dispatch(deleteSelectedInputFields({ pageIndex: selectedPageIndex }));
  };

  const onBulkParentTitleChange = (title) => {
    const groupNumber = savedParentTitles.indexOf(title) !== -1
      ? savedParentTitles.indexOf(title) + 1
      : savedParentTitles.length + 1;
    const parentTitleObj = { title, groupNumber };
    dispatch(
      updateSelectedInputFields({
        pageIndex: selectedPageIndex,
        updates: { parentTitle: parentTitleObj },
      })
    );
  };

  const onBulkSubTitleChange = (subTitle) => {
    dispatch(
      updateSelectedInputFields({
        pageIndex: selectedPageIndex,
        updates: { subTitle },
      })
    );
  };

  const bulkSavedSubTitles = useMemo(() => {
    if (!selectedForm?.inputFields) return [];
    const currentPageFields = Array.isArray(selectedForm.inputFields[0])
      ? selectedForm.inputFields[selectedPageIndex] || []
      : selectedForm.inputFields;

    const uniqueSubTitles = [
      ...new Set(
        currentPageFields
          .filter((field) => field.subTitle && field.subTitle.trim())
          .map((field) => field.subTitle.trim())
      ),
    ];
    return uniqueSubTitles;
  }, [selectedForm, selectedPageIndex]);

  // Multi-select bulk actions panel
  if (selectedInputFieldIds.length > 1 && !selectedInputField) {
    return (
      <div style={styles.panel}>
        <div style={styles.headerRow}>
          {selectedInputFieldIds.length} kenttää valittu
        </div>
        <div
          style={{
            fontSize: 12,
            color: 'rgba(255,255,255,0.6)',
            lineHeight: 1.5,
          }}
        >
          Ctrl+klikkaa valitaksesi lisää kenttiä, tai klikkaa &quot;Kopioi alle&quot;
          kopioidaksesi kaikki valitut kentät riviksi alle.
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Yläotsikko</div>
          <input
            type="text"
            style={styles.input}
            placeholder="Kirjoita yläotsikko"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && e.target.value.trim()) {
                onBulkParentTitleChange(e.target.value.trim());
              }
            }}
            onBlur={(e) => {
              if (e.target.value.trim()) {
                onBulkParentTitleChange(e.target.value.trim());
              }
            }}
          />
          {savedParentTitles.length > 0 && (
            <select
              style={{ ...styles.select, marginTop: 8 }}
              value=""
              onChange={(e) =>
                e.target.value && onBulkParentTitleChange(e.target.value)
              }
            >
              <option value="">Valitse yläotsikko</option>
              {savedParentTitles.map((title, index) => (
                <option key={title} value={title}>
                  {index + 1}. {title}
                </option>
              ))}
            </select>
          )}
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Alaotsikko</div>
          <input
            type="text"
            style={styles.input}
            placeholder="Kirjoita alaotsikko"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && e.target.value.trim()) {
                onBulkSubTitleChange(e.target.value.trim());
              }
            }}
            onBlur={(e) => {
              if (e.target.value.trim()) {
                onBulkSubTitleChange(e.target.value.trim());
              }
            }}
          />
          {bulkSavedSubTitles.length > 0 && (
            <select
              style={{ ...styles.select, marginTop: 8 }}
              value=""
              onChange={(e) =>
                e.target.value && onBulkSubTitleChange(e.target.value)
              }
            >
              <option value="">Valitse alaotsikko</option>
              {bulkSavedSubTitles.map((subTitle, index) => (
                <option key={subTitle} value={subTitle}>
                  {index + 1}. {subTitle}
                </option>
              ))}
            </select>
          )}
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Fontin koko</div>
          <select
            style={styles.select}
            defaultValue=""
            onChange={(e) => {
              if (e.target.value) {
                dispatch(
                  updateSelectedInputFields({
                    pageIndex: selectedPageIndex,
                    updates: { textSize: Number(e.target.value) },
                  })
                );
              }
            }}
          >
            <option value="" disabled>Valitse fontin koko</option>
            {[4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18].map((size) => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
        </div>

        <div style={styles.grid2}>
          <div style={styles.field}>
            <div style={styles.label}>X</div>
            <input
              type="number"
              style={styles.input}
              placeholder="px"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.target.value) {
                  dispatch(
                    updateSelectedInputFields({
                      pageIndex: selectedPageIndex,
                      updates: { x: Number(e.target.value) },
                    })
                  );
                }
              }}
            />
          </div>
          <div style={styles.field}>
            <div style={styles.label}>Y</div>
            <input
              type="number"
              style={styles.input}
              placeholder="px"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.target.value) {
                  dispatch(
                    updateSelectedInputFields({
                      pageIndex: selectedPageIndex,
                      updates: { y: Number(e.target.value) },
                    })
                  );
                }
              }}
            />
          </div>
        </div>

        <div style={styles.grid2}>
          <div style={styles.field}>
            <div style={styles.label}>Leveys</div>
            <input
              type="number"
              style={styles.input}
              placeholder="px"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.target.value) {
                  dispatch(
                    updateSelectedInputFields({
                      pageIndex: selectedPageIndex,
                      updates: { width: Number(e.target.value) },
                    })
                  );
                }
              }}
            />
          </div>
          <div style={styles.field}>
            <div style={styles.label}>Korkeus</div>
            <input
              type="number"
              style={styles.input}
              placeholder="px"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && e.target.value) {
                  dispatch(
                    updateSelectedInputFields({
                      pageIndex: selectedPageIndex,
                      updates: { height: Number(e.target.value) },
                    })
                  );
                }
              }}
            />
          </div>
        </div>

        <div style={styles.footer}>
          <button
            style={styles.btn}
            onClick={() =>
              dispatch(
                equalizeSelectedRowGaps({ pageIndex: selectedPageIndex })
              )
            }
          >
            Tasaa välit
          </button>
          <button style={styles.btn} onClick={onCopySelectedFields}>
            Kopioi alle ({selectedInputFieldIds.length})
          </button>
          <button style={styles.dangerBtn} onClick={onDeleteSelectedFields}>
            Poista ({selectedInputFieldIds.length})
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.panel}>
      <div style={styles.headerRow}>Lomakekenttä</div>

      {/* X / Y side-by-side to save vertical space */}
      <div style={styles.grid2}>
        <div style={styles.field}>
          <div style={styles.label}>X</div>
          <input
            type="text"
            name="x"
            style={styles.input}
            value={formData.x}
            onChange={handleChange}
          />
        </div>
        <div style={styles.field}>
          <div style={styles.label}>Y</div>
          <input
            type="text"
            name="y"
            style={styles.input}
            value={formData.y}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Width / Height */}
      <div style={styles.grid2}>
        <div style={styles.field}>
          <div style={styles.label}>Leveys</div>
          <input
            type="text"
            name="width"
            style={styles.input}
            value={formData.width}
            onChange={handleChange}
          />
        </div>
        <div style={styles.field}>
          <div style={styles.label}>Korkeus</div>
          <input
            type="text"
            name="height"
            style={styles.input}
            value={formData.height}
            onChange={handleChange}
          />
        </div>
      </div>

      <div style={styles.field}>
        <div style={styles.label}>Yläotsikko</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <input
              type="text"
              name="parentTitle"
              style={styles.input}
              value={
                typeof formData.parentTitle === 'object'
                  ? formData.parentTitle.title
                  : formData.parentTitle
              }
              onChange={handleChange}
              placeholder="Kirjoita uusi tai valitse alta"
            />
          </div>
        </div>
        {savedParentTitles.length > 0 && (
          <select
            style={{ ...styles.select, marginTop: 8 }}
            value=""
            onChange={(e) =>
              e.target.value && selectParentTitle(e.target.value)
            }
          >
            <option value="">Valitse yläotsikko</option>
            {savedParentTitles.map((title, index) => (
              <option key={title} value={title}>
                {index + 1}. {title}
              </option>
            ))}
          </select>
        )}

        {formData.parentTitle &&
          (typeof formData.parentTitle === 'object'
            ? formData.parentTitle.title
            : formData.parentTitle) && (
            <>
              <div style={styles.label}>Alaotsikko</div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
                <div style={{ flex: 1 }}>
                  <input
                    type="text"
                    name="subTitle"
                    style={styles.input}
                    value={formData.subTitle}
                    onChange={handleChange}
                    placeholder="Kirjoita uusi tai valitse alta"
                  />
                </div>
              </div>
              {savedSubTitles.length > 0 && (
                <select
                  style={{ ...styles.select, marginTop: 8 }}
                  value=""
                  onChange={(e) =>
                    e.target.value && selectSubTitle(e.target.value)
                  }
                >
                  <option value="">Valitse alaotsikko</option>
                  {savedSubTitles.map((subTitle, index) => (
                    <option key={subTitle} value={subTitle}>
                      {index + 1}. {subTitle}
                    </option>
                  ))}
                </select>
              )}
            </>
          )}
      </div>

      <div style={styles.field}>
        <div style={styles.label}>Riippuvaisuus</div>
        <select
          type="text"
          name="dependency"
          style={styles.select}
          value={selectedInputField.dependency || ''}
          onChange={(e) => selectDependency(e.target.value)}
        >
          <option value="">Valitse riippuvaisuus</option>
          {checkboxAndRadioButtons.map((field, index) => (
            <option
              key={field.id}
              value={field.id}
              disabled={fieldIdsDependingOnSelected.has(field.id)}
            >
              {index + 1}. {field.title} {`(${field.originalIndex})`}
              {field.id === selectedInputField.id
                ? ' - tämä kenttä'
                : fieldIdsDependingOnSelected.has(field.id)
                  ? ' - riippuu tästä kentästä'
                  : ''}
            </option>
          ))}
        </select>
      </div>

      <div style={styles.field}>
        <div style={styles.label}>Otsikko</div>
        <input
          type="text"
          name="title"
          style={styles.input}
          value={formData.title}
          onChange={handleChange}
        />
      </div>

      <div style={styles.field}>
        <div style={styles.label}>
          {formData.type?.name === 'runningNumber'
            ? 'Teksti ennen numeroa'
            : 'Teksti'}
        </div>
        <input
          type="text"
          name="text"
          style={styles.input}
          value={formData.text}
          onChange={handleChange}
          placeholder={
            formData.type?.name === 'runningNumber' ? 'esim. Nro:' : undefined
          }
        />
      </div>

      {/* <div style={styles.field}>
        <div style={styles.label}>Tyyppi</div>
        <CustomGroupedSelect
          name="type"
          value={formData.type?.name || ''}
          groups={typeOptions}
          onChange={handleChange}
          placeholder="Valitse tyyppi"
        />
      </div> */}

      <div style={styles.field}>
        <div style={styles.label}>Tyyppi</div>
        <select
          style={styles.select}
          name="type"
          value={formData.type?.name || ''}
          onChange={handleChange}
        >
          <option
            value=""
            style={{
              color: 'CanvasText',
              backgroundColor: 'Canvas',
              forcedColorAdjust: 'none',
              WebkitTextFillColor: 'CanvasText',
            }}
          >
            Valitse tyyppi
          </option>

          {typeOptions.map((group) => (
            <optgroup
              key={group.label}
              label={group.label}
              style={{
                color: 'CanvasText',
                backgroundColor: 'Canvas',
                fontWeight: 'bold',
                forcedColorAdjust: 'none',
                WebkitTextFillColor: 'CanvasText',
              }}
            >
              {group.options.map((option) => (
                <option
                  key={option.name}
                  value={option.name}
                  disabled={
                    option.name === 'runningNumber' &&
                    hasOtherRunningNumberField
                  }
                  style={{
                    color: 'CanvasText',
                    backgroundColor: 'Canvas',
                    forcedColorAdjust: 'none',
                    WebkitTextFillColor: 'CanvasText',
                  }}
                >
                  {option.displayName}
                  {option.name === 'runningNumber' &&
                  hasOtherRunningNumberField
                    ? ' - on jo lomakkeella'
                    : ''}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>

      <div style={styles.field}>
        <div style={styles.label}>Fontin koko</div>
        <select
          style={styles.select}
          name="textSize"
          value={formData.textSize}
          onChange={handleChange}
        >
          <option value={4}>4</option>
          <option value={5}>5</option>
          <option value={6}>6</option>
          <option value={7}>7</option>
          <option value={8}>8</option>
          <option value={9}>9</option>
          <option value={10}>10</option>
          <option value={11}>11</option>
          <option value={12}>12</option>
          <option value={13}>13</option>
          <option value={14}>14</option>
          <option value={15}>15</option>
          <option value={16}>16</option>
          <option value={17}>17</option>
          <option value={18}>18</option>
        </select>
      </div>

      <div style={styles.field}>
        <div style={styles.label}>Järjestysnumero</div>
        <input
          type="number"
          name="originalIndex"
          style={styles.input}
          value={formData.originalIndex}
          onChange={handleChange}
        />
      </div>

      <div style={styles.footer}>
        <button style={styles.dangerBtn} onClick={onDeleteInputField}>
          Poista
        </button>
        {formData.type?.name !== 'runningNumber' && (
          <button style={styles.textBtn} onClick={onCopyInputField}>
            Kopio viereen
          </button>
        )}
      </div>
    </div>
  );
}
